<i18n
  src="@/locales/views/customer/quality_control/destination/edit_inspect.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      name="customer_quality_control_destination_show_inspect_path"
      :params="{
        customer_id: customer_id,
        container_id: container?.id,
        quality_inspect_id: quality_inspect_id,
        agro_exporter_id: agro_exporter_id,
      }"
    />

    <bread-crumbs
      :labels="[
        module_name,
        agro_exporter_process.name,
        container.container_code,
        template?.name
      ]"
    >
    </bread-crumbs>

    <template v-if="load_data_general">
      <container-info :container="container" />
      <div class="mt-8">
        <div class="panel">
          <div class="panel-header">
            <h3 class="panel-header-title">
              {{ $t("labels.title") }}
            </h3>
          </div>

          <div class="panel-body">
            <div
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 w-full pb-6"
            >
              <div class="sm:col-span-3">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.registered_at") }}
                </label>
                <div class="mt-1 relative rounded-md shadow-sm z-10">
                  <date-form
                    v-if="registered_at_charged"
                    v-model="registered_at"
                    :first-day-of-week="2"
                    locale="es"
                    show-iso-weeknumbers
                  ></date-form>
                </div>
              </div>
              <div class="sm:col-span-3" v-if="template?.control_exportation">
                <label
                  for="origin_export_id"
                  class="block text-sm font-medium text-gray-700"
                >
                  Productor(a)
                </label>
                <div class="mt-1">
                  <!-- <select-form
                    v-if="exported_batch_id && exported_batch_options.length > 0"
                    v-model="exported_batch_id"
                    :options="exported_batch_options"
                    :disabled="true"
                  /> -->
                  <div class="content-data">
                    {{ exported_batch_selected?.name }}
                  </div>
                </div>
              </div>
              <div
                class="sm:col-span-3"
                v-if="
                  template &&
                  template?.use_samplings &&
                  !template?.specific_sampling
                "
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.samplings") }}
                </label>
                <div class="mt-1">
                  <input
                    disabled
                    type="text"
                    v-model.lazy.number="samplings"
                    class="input-text"
                  />
                </div>
              </div>
            </div>
            <template v-if="template && quality_inspect_data_charged">
              <sampling-layout
                v-if="template.use_samplings"
                v-model="quality_samplings"
                :samplings="samplings"
                :quality_template="template"
                :default_quality_samplings="default_quality_samplings"
              />
              <general-layout
                v-else
                v-model="quality_generals"
                :quality_template="template"
                :default_quality_generals="default_quality_generals"
              />
            </template>
          </div>
          <div class="panel-footer">
            <div class="panel-footer-actions">
              <white-button
                @click.prevent="gotToShowQualityInspect()"
                :label="$t('labels.cancel_button')"
              />
              <span class="space-actions"></span>
              <success-button
                v-if="!proc_save_button"
                @click.prevent="submit()"
                :label="$t('labels.save_button')"
              />
              <success-button-processing v-else :label="$t('labels.save_button')" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/quality_control/container/edit_inspect.js";

import ContainerInfo from "@/components/views/customer/quality_control/destination/ContainerInfo.vue";
import GoBackLink from "@/components/views/layout/GoBackLink";
import SamplingLayout from "@/components/views/layout/quality_control/SamplingLayout.vue";
import GeneralLayout from "@/components/views/layout/quality_control/GeneralLayout.vue";

import moment from "moment";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: {
    ContainerInfo,
    GoBackLink,
    BreadCrumbs,
    SamplingLayout,
    GeneralLayout,
  },
  props: {
    customer_id: { required: true },
    agro_exporter_id: {
      required: true
    },
    container_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    quality_template_id: {
      required: true
    },
    quality_inspect_id: {
      required: true
    },
  },
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      proc_save_button: false,
      container: {},
      template: null,
      samplings: null,
      quality_inspect: null,
      registered_at: null,
      registered_at_charged: false,
      quality_inspect_data_charged: false,
      exported_batch: null,
      exported_batch_id: null,
      default_quality_samplings: [],
      default_quality_generals: [],
      sampling_values: {},
      general_values: {},
      option_tabs: [],
      exported_batches: [],
      exported_batch_options: [],
      quality_generals: [],
      quality_samplings: [],
    };
  },
  computed: {
    can_send: function () {
      return this.valid_data && !this.proc_save_button && this.template;
    },
    exported_batch_selected: function () {
      return this.exported_batch_options.find(
        (option) => option.id == this.exported_batch_id
      );
    },
    registered_at_formatted: function () {
      return moment(this.registered_at).format("YYYY-MM-DD");
    },
    valid_data: function () {
      return (
        Boolean(this.registered_at) &&
        (Boolean(this.samplings) || !this.template?.use_samplings)
      );
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchContainer();
        this.fetchTemplate().then(() => {
          if (this.template?.control_exportation) this.fetchExportedBatches();
        });
        this.fetchInspect();
      })
    );
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id
      });
      this.agro_exporter_process = response.data;
    },
    exportedBatchOption: function (exported_batch) {
      let label = "";
      if (exported_batch.producer) {
        label += exported_batch.producer;
        if (exported_batch.organization)
          label += ` (${exported_batch.organization})`;
      } else label += exported_batch.organization;
      return {
        name: label,
        id: exported_batch.id
      };
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id
      });
      this.container = response.data;
    },
    fetchExportedBatches: async function () {
      let response = await Requester.fetchExportedBatches({
        customer_id: this.customer_id,
        container_id: this.container_id
      });
      this.exported_batches = response.data;
      this.exported_batches.forEach(exported_batch => {
        this.exported_batch_options.push(
          this.exportedBatchOption(exported_batch)
        );
      });
    },
    fetchTemplate: async function () {
      let response = await Requester.fetchTemplate({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.template = response.data;
      if (this.template?.specific_sampling)
        this.samplings = this.template?.samplings;
    },
    fetchInspect: async function () {
      let response = await Requester.fetchInspect({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        quality_inspect_id: this.quality_inspect_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.quality_inspect = response.data;
      this.registered_at = this.quality_inspect.registered_at.split(".")[0];
      this.exported_batch_id = this.quality_inspect.exported_batch_id;
      this.samplings = this.quality_inspect.samplings;
      this.default_quality_samplings = this.quality_inspect.quality_samplings;
      this.default_quality_generals = this.quality_inspect.quality_generals;
      this.registered_at_charged = true;
      this.load_data_general = true;
      this.quality_inspect_data_charged = true;
    },
    gotToShowQualityInspect: function () {
      this.$router.push({
        name: "customer_quality_control_destination_show_inspect_path",
        params: {
          container_id: this.container_id,
          quality_inspect_id: this.quality_inspect_id,
          agro_exporter_id: this.agro_exporter_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.proc_save_button = true;
      if (this.template?.use_samplings) await this.submit_with_samplings();
      else await this.submit_without_samplings();
      this.proc_save_button = false;
    },
    submit_with_samplings: async function () {
      try {
        let response = await Requester.updateWithSamplings({
          quality_inspect_id: this.quality_inspect_id,
          container_id: this.container_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id,
          registered_at: this.registered_at_formatted,
          exported_batch_id: this.exported_batch_id,
          samplings: this.samplings,
          quality_samplings: this.quality_samplings
        });
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.gotToShowQualityInspect();
      } catch (error) {
        console.log(error);
      }
    },
    submit_without_samplings: async function () {
      try {
        let response = await Requester.updateWithoutSamplings({
          quality_inspect_id: this.quality_inspect_id,
          container_id: this.container_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id,
          registered_at: this.registered_at_formatted,
          exported_batch_id: this.exported_batch_id,
          quality_generals: this.quality_generals
        });
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.gotToShowQualityInspect();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
